import CreatePage from '@/modules/traceability-report/views/pages/create/index.vue';
import EditPage from '@/modules/traceability-report/views/pages/edit/index.vue';
import ClonePage from '@/modules/traceability-report/views/pages/clone/index.vue';
import ViewPage from '@/modules/traceability-report/views/pages/view/index.vue';

const routes = [
    {
        path: '/relatorio-rastreabilidade/cadastro',
        name: 'relatorio-rastreabilidade-cadastro',
        meta: {
            roles: [
                'ROLE_FEATURE_RELATORIO_RASTREABILIDADE'
            ]
        },
        component: CreatePage
    },
    {
        path: '/relatorio-rastreabilidade/:id/editar',
        name: 'relatorio-rastreabilidade-editar',
        meta: {
            roles: [
                'ROLE_FEATURE_RELATORIO_RASTREABILIDADE'
            ]
        },
        component: EditPage
    },
    {
        path: '/relatorio-rastreabilidade/:id/clonar',
        name: 'relatorio-rastreabilidade-clonar',
        meta: {
            roles: [
                'ROLE_FEATURE_RELATORIO_RASTREABILIDADE'
            ]
        },
        component: ClonePage
    },
    {
        path: '/relatorio-rastreabilidade/:id/visualizar',
        name: 'relatorio-rastreabilidade-visualizar',
        meta: {
            roles: [
                'ROLE_FEATURE_RELATORIO_RASTREABILIDADE'
            ]
        },
        component: ViewPage
    }
];

export default routes;
